// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wYOHI","clinicsSelect":"styles_clinicsSelect__3G8um"};